import { webAudioContext } from "./webaudio_context";
import { NodeHtml } from "./node_html";

class NodeFilterHtml extends NodeHtml {
  handlers = this.extendParentHandlers({
    type: { handler: this.setType, type: "enum", default: "lowpass", values: ["lowpass", "highpass", "allpass"] },
    frequency: { handler: this.setFrequency, type: "float", default: 20, min: 20, max: 22050 },
    resonance: { handler: this.setResonance, type: "float", default: 1, min: 0.0001, max: 1000 },
  });

  setProps(dnode) {
    dnode.input = webAudioContext.context.createBiquadFilter();
    dnode.input.type = dnode.props.type;
    dnode.input.frequency.value = dnode.props.frequency;
    dnode.input.Q.value = dnode.props.resonance;

    if (dnode.props.rolloff === "12dB") {
      dnode.output = dnode.input;
      super.setProps(dnode);
      return;
    }

    dnode.output = webAudioContext.context.createBiquadFilter();
    dnode.output.type = this.type;
    dnode.output.frequency.value = this.frequency;
    dnode.output.Q.value = this.resonance;
    dnode.input.connect(this.output);
    super.setProps(dnode);
  }

  setType(dnode) {
    const { type, rolloff } = dnode.props;
    dnode.input.type = type;

    if (rolloff === "24dB") {
      dnode.output.type = type;
    }
  }

  setFrequency(dnode) {
    const { frequency, rolloff } = dnode.props;
    dnode.input.frequency.value = frequency;

    if (rolloff === "24dB") {
      dnode.output.frequency.value = frequency;
    }
  }

  setResonance(dnode) {
    const { resonance } = dnode.props;
    dnode.input.Q.value = resonance;

    if (dnode.props.rolloff === "24dB") {
      dnode.output.Q.value = resonance;
    }
  }

  disconnect(dnode) {
    if (dnode.props.rolloff === "24dB") {
      this.input.disconnect();
    }

    super.destroy();
  }
}

const nodeFilterHtml = new NodeFilterHtml("webaudio:node:filter");
export { NodeFilterHtml, nodeFilterHtml };
